import { StrictRouteConfig } from "@/router/router";

export const featureRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/features",
        name: "features",
        component: () => import(/* webpackChunkName: "feature" */ "@/views/feature/features.vue"),
        meta: {
            label: "Features",
            title: "Manage features",
            includeInNavigation: true,
            icon: "desk-lamp",
            matchExact: true,
            path: ["dashboard", "features"],
            order: 60,
            requiresAuth: true,
            requiresAbility: ["manage", "Features"],
        },
    },
];
